import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { withDisclosureStatus } from '../gridColumns';
import { useValidation } from "../../../hooks/useValidation";
import { useAuthorization } from "../../../hooks/useAuthorization";
import { useAccount, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Grid, Stack } from '@mui/material';
import {format} from 'date-fns';
import _ from "lodash";
import { GetAssignedFileRecords, SearchAssignedFileRecords } from "../../../services/dashboard.service";
import { GetAssignedFilesMetaData } from "../../../services/graph-service";
import { tokenRequest } from "../../../auth/authConfig";
import StyledButton from '../../../components/elements/StyledButton';
import DataTable from '../../../components/DataTable';
import Backdrop from '../../../components/elements/Loader';
import { IoWarning } from "react-icons/io5";
import StyledSwitch from '../../../components/StyledSwitch';
import AutoCompleteTextField from '../../../components/AutoComplete';
import { useNavigationParameters } from "../../../hooks/useNavigationParameters";
import * as Constants from "../../../helper/constants";

function TopAssignedFiles(props) {

    const [canCreate, canRead, canUpdate, canDelete] = useAuthorization();
    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [appendExistingNavigationParameters,  removeDuplicatedNavigationParameters , prepareNavigationParameters] = useNavigationParameters();


    const navigate = useNavigate();
    const [gridColumns, setGridColumns] = useState([]);
    const [gridRows, setGridRows] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [filterByDueDate, setFilterByDueDate] = useState(searchParams.get("topassignedfilesduedate")== "true"? true: false);
    const [showViewAll, setShowViewAll] = useState(false);
    const [isDataReady, setIsDataReady] = useState(false);

    const [lsms, setLsms] = useState([]);
    const [selectedLSMs, setSelectedLSMs] = useState([]);
    const [userManagers, setUserManagers] = useState([]);
    const [allLawyers, setAllLawyers] = useState([]);
    const [lawyers, setLawyers] = useState([]);
    const [selectedLawyers, setSelectedLawyers] = useState([]);
    const [inputValuesOfLSMs, setInputValuesOfLSMs] = useState([]);
    const [inputValuesOfLawyers, setInputValuesOfLawyers] = useState([]);

    // #region PageLoad
    useEffect(() => {
        window.scrollTo(0, 0);
        setInitialGridColumns();
    }, []);

    useEffect(() => {
        LoadInitialData(filterByDueDate);
    }, [instance]);

    function LoadInitialData(filterByDueDate) {
        if (account) {
            instance.acquireTokenSilent(
                tokenRequest
            ).then(async (response) => {
                if (response) {
                    await setInitialGridData(response.accessToken, filterByDueDate);
                    await GetAssignedFilesMetaData(response.accessToken).then((metaData) => {
                        if (metaData) {
                            if (metaData.lsms)
                                setLsms(metaData.lsms);
                            if (metaData.usersWithManagers)
                                setUserManagers(metaData.usersWithManagers);
                            if (metaData.lawyers) {
                                setLawyers(metaData.lawyers);
                                setAllLawyers(metaData.lawyers);
                            }
                        }
                    });
                }
            });
        }
    }

    const setInitialGridData = async (token, dueDate) => {
        await GetAssignedFileRecords(token, dueDate, 0, 0).then((rowData) => {
            setInitialGridColumns();
            if (rowData) {
                setGridRows(rowData);
                setShowViewAll(false);
            }
        }).then(() => {setIsDataReady(true)});
    }

    const setInitialGridColumns = () => {
        setGridColumns(withDisclosureStatus([{ field: 'idText', width: 100, headerName: 'ID', renderCell: true, editable: false, hide : true },
        { field: 'requestType', width: 150, headerName: 'Request Type', editable: false },
        { field: 'requestor', width: 150, headerName: 'Assigned Lawyer', editable: false },
        { field: 'assignedOn', type: 'date', width: 150, headerName: 'Date Assigned', renderDate: true, editable: false },
        { field: 'upcomingCourtDate', type: 'date', width: 150, headerName: 'Next Court Date', renderWarning: true, editable: false }, 
        { field: 'status', width: 150, headerName: 'Status', editable: false }, 
        { field: 'modifiedOn', type: 'date',width: 150, headerName: 'Last Updated Date', renderDate: true, editable: false },
        { field: 'assignedTo', width: 180, headerName: 'Agency Assigned', editable: false },
        { field: 'hasDisclosureOrdered', width: 220, headerName: 'Disclosure has been Ordered?', editable: false },
        { field: 'disclosureUploaded', width: 160, headerName: 'Disclosure Uploaded?', editable: false },
        { field: 'firstName', width: 180, headerName: 'First Name', editable: false },
        { field: 'lastName', width: 180, headerName: 'Last Name', editable: false },
        { field: 'isOutDated', width: 250, headerName: 'Outdated?', editable: false, hide: true },
        { field: 'clientFileId', width: 120, headerName: 'Client File ID', editable: false, hide: true }]));
    }
    const columns = [];
 

    function onRowDoubleClicked(item) {
        var pageValue = item.row.idText.split('-')[0];
        var itemId = item.row.idText.split('-')[1];
        switch (pageValue) {
            case 'AR':
                navigate(removeDuplicatedNavigationParameters(`${prepareNavigationParameters(Constants.AGENCYREQUEST, new Array(itemId, item.row.clientFileId), 1)}&root=topassignedfiles&topassignedfilesduedate=${filterByDueDate}&page=topassignedfiles`));
                break;
            case 'I':
                navigate(removeDuplicatedNavigationParameters(`${prepareNavigationParameters(Constants.INTERACRTION, new Array(itemId, item.row.clientFileId), 1)}&root=topassignedfiles&topassignedfilesduedate=${filterByDueDate}&page=topassignedfiles`));
                break;
        }
    }

    gridColumns.forEach((columnHeader) => {
        columns.push(
            {
                field: columnHeader.field,
                renderHeader: () => (<div style={{ font: 'normal normal normal 15px/16px Franklin Gothic Medium', color: "#000000" }}>{columnHeader.headerName}</div>),
                renderCell: (params) => (
                    (columnHeader.renderWarning ? (((new Date() - new Date(params.row.upcomingCourtDate)) / (1000 * 3600 * 24) > 7) && params.row.isOutDated == '1') ? <> {params.value != null ? format(new Date(params.value), 'dd-MMM-yyyy') : null} {params.value != null && <IoWarning title="Outdated Record" size={18} style={{ color: "#d32f2f", marginLeft: "5px" }} /> } </> : <>{params.value != null ? format(new Date(params.value), 'dd-MMM-yyyy') : null}  </> : 
                    (columnHeader.renderDate ? <>{params.value != null ? format(new Date(params.value), 'dd-MMM-yyyy') : null}  </>: null ))),
                width: columnHeader.width,
                editable: columnHeader.editable,
                hide: columnHeader.hide
            },
        );
    });

    const onFilterChanged = (event) => {
        setFilterByDueDate(event.target.checked);
        LoadInitialData(event.target.checked);
    };

    const createSelectedArrayOfObjects = (inputValues, options) => {
        const arrayOfObjects = [];
        inputValues.forEach((InputValue) => {
            let selectedOption = options.find((option) => option?.label == InputValue)
            arrayOfObjects.push(selectedOption);
        })
        return arrayOfObjects;
    };

    const resolveLawyersFromLSMs = (lsmList) => {
        var resolvedLawyers = [];
        lsmList.forEach(element => {
            const usersWithManager = _.filter(userManagers, { 'manager': element.value });
            usersWithManager.forEach(user => {
                const searchedUser = _.filter(allLawyers, { 'value': user.value });
                resolvedLawyers = resolvedLawyers.concat(searchedUser);
            });
        });
        return resolvedLawyers;
    };

    const onSelectedLegalServiceManagersChanged = (event, newInputValues) => {
        setInputValuesOfLSMs(newInputValues);
        const newArrayOfLSMs = createSelectedArrayOfObjects(newInputValues, lsms);
        setSelectedLSMs(newArrayOfLSMs);

        if (newArrayOfLSMs.length == 0) {
            setLawyers(allLawyers);
            setSelectedLawyers(null);
        }
        else {
            const searchedLawyers = resolveLawyersFromLSMs(newArrayOfLSMs);
            setLawyers(searchedLawyers);
        }
    };

    const onSelectedAgencyAssignedLawyersChanged = (event, newInputValues) => {
        setInputValuesOfLawyers(newInputValues);
        setSelectedLawyers(createSelectedArrayOfObjects(newInputValues, lawyers));
    };

    const GetSearchText = (searchArray) => {
        if (!searchArray || searchArray.length === 0) return "";
        return searchArray.map(item => "'" + JSON.stringify(item).replace(/'/g, "\\'") + "'").join(",");
    };

    function GetSearchBy() {
        var lawyersSearchText = "";
        var searchedLawyers = [];

        if (selectedLSMs && selectedLSMs.length > 0 && (!selectedLawyers || selectedLawyers.length === 0)) {
            searchedLawyers = resolveLawyersFromLSMs(selectedLSMs);
            lawyersSearchText = GetSearchText(searchedLawyers);
        }
        else if (selectedLawyers) {
            lawyersSearchText = GetSearchText(selectedLawyers);
        }

        const lawyersSearch = { columnName: "AssignedTo", searchValue: lawyersSearchText };

        return [lawyersSearch];
    }

    const onSearchClicked = () => {
        setIsDataReady(false);

        const searchBy = GetSearchBy();

        if (searchBy && searchBy[0].searchValue !== "") {
            if (account) {
                instance.acquireTokenSilent(
                    tokenRequest
                ).then((response) => {
                    if (response) {
                        SearchAssignedFileRecords(response.accessToken, searchBy, filterByDueDate, 0, 0).then((data) => {
                            if (data) {
                                setGridRows(data);
                            }
                        }).catch((error) => {
                            console.error('Search failed:', error);
                            // Optionally show a toast notification here
                        }).finally(() => {
                            setIsDataReady(true);
                        });
                    }
                }).catch((error) => {
                    console.error('Token acquisition failed:', error);
                    setIsDataReady(true);
                });
            }
        }
        else {
            LoadInitialData(filterByDueDate);
        }
    };
    //#endregion     

    if (canRead("assigned-files-dashboard", null)) { //ToDo - Change this role
        if (isDataReady) {
            return (
            <Grid container>
                <Grid item xs={12} md={4} style={{ margin: "0px 0px 10px 0px" }}>
                    <AutoCompleteTextField label="Legal Services Managers (LSMs)" options={lsms} multiple={true}
                        value={inputValuesOfLSMs} onChange={onSelectedLegalServiceManagersChanged} />
                </Grid>
                <Grid item xs={12} md={4} style={{ margin: "0px 0px 10px 0px" }}>
                    <AutoCompleteTextField label="Assigned Lawyers" options={lawyers} multiple={true}
                        value={inputValuesOfLawyers} onChange={onSelectedAgencyAssignedLawyersChanged} />
                </Grid>
                <Grid item xs={12} md={4} style={{ textAlign: "center", margin: "0px 0px 10px 0px" }}>
                    <StyledButton variant={"outlined"} color="error" onClick={onSearchClicked} >Search</StyledButton>
                </Grid>
                <Grid item xs={12} md={12} style={{ font: "normal normal normal 15px/25px Franklin Gothic Medium", letterSpacing: "0px", color: "#585454", opacity: "1" }}>
                    <Stack direction="row" alignItems="center"> <div style={{ marginRight: "10px" }}>Due Today: </div> <StyledSwitch style={{ textAlign: "left", font: "normal normal bold 15px/25px Franklin Gothic Medium", letterSpacing: "0px", color: " #585454", opacity: "1" }} checked={filterByDueDate} onChange={onFilterChanged} /> </Stack>
                </Grid>
                
                <DataTable columns={columns} rows={gridRows} totalCount={props.totalCount} onRowDoubleClick={onRowDoubleClicked}/>

                {showViewAll &&
                    <Grid item xs={12} md={12} style={{ textAlign: "center" , margin: "5px 0px 20px 0px"}}>
                        <StyledButton variant={"outlined"} color="error" onClick={() => navigate(removeDuplicatedNavigationParameters(`${prepareNavigationParameters(Constants.ASSIGNEDFILES, new Array(filterByDueDate))}&page=topassignedfiles&root=topassignedfiles`))} >View All</StyledButton>
                    </Grid>}
            </Grid>

            );
        } else {
            return (
                <Backdrop />
            );
        }
    } else {
        return (
            <Grid container style={{ padding: "10px 20px 20px 20px", border: "1px solid #7F8284", margin: "10px 0px 10px 0px", borderRadius: "8px" }}>
                <Grid item xs={12} md={12} style={{
                    textAlign: "left", font: "normal normal normal 17px/22px Franklin Gothic Medium",
                    letterSpacing: "0px", color: " #000000", opacity: "1", marginBottom: "15px"
                }}>Assigned Files
                </Grid>
                <Grid item xs={12} md={12} style={{
                    textAlign: "left", font: "normal normal 200 15px/17px Franklin Gothic Medium",
                    letterSpacing: "0px", color: " #000000", opacity: "1",
                }}>** You are not authorized to view these details **
                </Grid>
            </Grid>
        );
    }
}

export default TopAssignedFiles;